import React from 'react'
import { R } from '../../R/R'
import './FullPageHeader.scss'

export const FullPageHeader = ({ title }: { title: string }) => {
	return (
		<div className='fullpage-header'>
			<img src={R.images.logoMvp} alt='logo' />
			<h1 className='title-label'>{title}</h1>
			<div className='gradient-separator' />
		</div>
	)
}
